/**
 * HomePage Component
 * Main landing page with all homepage sections
 */

import { useEffect } from 'react';
import { Layout } from '~/components/layout/Layout';
import { HeroSection } from '~/components/home/HeroSection';
import { TrustBadges } from '~/components/home/TrustBadges';
import { FeaturedCollections } from '~/components/home/FeaturedCollections';
import { FeaturedProducts } from '~/components/home/FeaturedProducts';
import { BrandShowcase } from '~/components/home/BrandShowcase';
import { CTASection } from '~/components/home/CTASection';
import { generateHomepageStructuredData } from '~/lib/seo/structured-data';
import { generateHomeMetaTags, applyMetaTags } from '~/lib/seo/meta-tags';

export function HomePage() {
  useEffect(() => {
    const meta = generateHomeMetaTags();
    applyMetaTags(meta);

    const structuredData = generateHomepageStructuredData();
    const scriptId = 'homepage-structured-data';
    let script = document.getElementById(scriptId);
    if (!script) {
      script = document.createElement('script');
      script.id = scriptId;
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(structuredData);

    return () => {
      const existingScript = document.getElementById(scriptId);
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, []);

  return (
    <Layout>
      <HeroSection />
      <TrustBadges />
      <FeaturedCollections />
      <FeaturedProducts />
      <BrandShowcase />
      <CTASection />
    </Layout>
  );
}
